import React from 'react'
import GicListComponent from './components/gicListComponent'

const GicList = () => {
  return (
    <>
      <GicListComponent title={'Gic Account Funded List'} status={'GIC Account Funded'} pathName={'gic.gicApproved'} />
    </>
  )
}

export default GicList
